import { useQuery } from '@hooks/reactQuery';

import { getMiddlewareStatuses } from '@api/middlewareSMO';

import { extractQueryParams } from '@utils/common';
import { optionsFormatted } from '@utils/formatter';

import { TNameTitle } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { MIDDLEWARE_SMO_STATUSES } from '@constants/queryKeys';

interface IUseQueryMiddlewareSMOStatusesReturned {
	middlewareStatuses: TSelectOption[];
	isLoadingMiddlewareStatuses: boolean;
}

const useQueryMiddlewareSMOStatuses = (): IUseQueryMiddlewareSMOStatusesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery<TNameTitle[], TSelectOption[]>({
		queryKey: [MIDDLEWARE_SMO_STATUSES],
		queryFn: extractQueryParams(getMiddlewareStatuses),
		select: (data): TSelectOption[] => optionsFormatted(data),
		...refetchOptions,
	});

	return {
		middlewareStatuses: data || [],
		isLoadingMiddlewareStatuses: (isLoading && !!data)
			|| isFetching,
	};
};

export default useQueryMiddlewareSMOStatuses;
